"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpritzTestArc = void 0;
var SpritzArc_1 = require("./SpritzArc");
var Token_1 = __importDefault(require("./utils/Token"));
var ethers_1 = require("ethers");
var core_1 = require("../arc-types/core");
var MockOracleFactory_1 = require("./typings/MockOracleFactory");
var SpritzTestArc = /** @class */ (function (_super) {
    __extends(SpritzTestArc, _super);
    function SpritzTestArc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpritzTestArc.init = function (signer, contracts) {
        return __awaiter(this, void 0, void 0, function () {
            var arc;
            return __generator(this, function (_a) {
                arc = new SpritzTestArc();
                arc.signer = signer;
                arc.core = contracts.core;
                arc.state = contracts.state;
                arc.syntheticAsset = contracts.syntheticAsset;
                arc.collateralAsset = contracts.collateralAsset;
                arc.oracle = contracts.oracle;
                return [2 /*return*/, arc];
            });
        });
    };
    SpritzTestArc.prototype._borrowSynthetic = function (amount, collateral, from, positionId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Token_1.default.approve(this.collateralAsset.address, from, this.core.address, collateral, {})];
                    case 1:
                        _c.sent();
                        _b = (_a = this.collateralAsset).mintShare;
                        return [4 /*yield*/, from.getAddress()];
                    case 2: return [4 /*yield*/, _b.apply(_a, [_c.sent(), collateral, {}])];
                    case 3:
                        _c.sent();
                        if (!!positionId) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.openPosition(collateral, amount, from, {})];
                    case 4: return [2 /*return*/, _c.sent()];
                    case 5: return [4 /*yield*/, this.borrow(positionId, collateral, amount, from, {})];
                    case 6: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    SpritzTestArc.prototype._repay = function (positionId, repayAmount, withdrawAmount, from) {
        return __awaiter(this, void 0, void 0, function () {
            var position, _a, _b, price, market;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.state.getPosition(positionId)];
                    case 1:
                        position = _c.sent();
                        if (!(position.borrowedAsset == core_1.AssetType.Collateral)) return [3 /*break*/, 5];
                        _b = (_a = this.collateralAsset).mintShare;
                        return [4 /*yield*/, from.getAddress()];
                    case 2: return [4 /*yield*/, _b.apply(_a, [_c.sent(), repayAmount, {}])];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, Token_1.default.approve(this.collateralAsset.address, from, this.core.address, repayAmount, {})];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 10];
                    case 5:
                        if (!(position.borrowedAsset == core_1.AssetType.Synthetic)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.oracle.fetchCurrentPrice()];
                    case 6:
                        price = _c.sent();
                        return [4 /*yield*/, this.state.market()];
                    case 7:
                        market = _c.sent();
                        return [4 /*yield*/, this._borrowSynthetic(repayAmount, price.value
                                .mul(repayAmount)
                                .div(ethers_1.BigNumber.from(10).pow(18))
                                .mul(market.collateralRatio.value)
                                .div(ethers_1.BigNumber.from(10).pow(18)), from)];
                    case 8:
                        _c.sent();
                        return [4 /*yield*/, Token_1.default.approve(this.syntheticAsset.address, from, this.core.address, repayAmount, {})];
                    case 9:
                        _c.sent();
                        _c.label = 10;
                    case 10: return [4 /*yield*/, this.repay(positionId, repayAmount, withdrawAmount, from, {})];
                    case 11: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    SpritzTestArc.prototype.updatePrice = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new MockOracleFactory_1.MockOracleFactory(this.signer).attach(this.oracle.address).setPrice({ value: value })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SpritzTestArc;
}(SpritzArc_1.SpritzArc));
exports.SpritzTestArc = SpritzTestArc;
//# sourceMappingURL=SpritzTestArc.js.map